var map = {
	"./biuro.jpg": "d19c",
	"./biuro2.jpg": "af83",
	"./front.jpg": "bafb",
	"./oryginal/biuro.jpg": "81b9",
	"./oryginal/biuro2.jpg": "6d78",
	"./oryginal/front.jpg": "5a79",
	"./oryginal/skp1.jpg": "8776",
	"./oryginal/skp2.jpg": "00e6",
	"./oryginal/skp3.jpg": "74b9",
	"./oryginal/warsztat1.jpg": "dcdb",
	"./oryginal/warsztat2.jpg": "f217",
	"./oryginal/warsztat3.jpg": "fce2",
	"./oryginal/warsztat4.jpg": "536b",
	"./skp1.jpg": "c6ac",
	"./skp2.jpg": "5843",
	"./skp3.jpg": "5d30",
	"./warsztat1.jpg": "9be0",
	"./warsztat2.jpg": "32de",
	"./warsztat3.jpg": "b4ec",
	"./warsztat4.jpg": "6778"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf52";